import api from './api';

const AuthService = {
  async signup({ name, email, password, role, companyName, country }) {
    const { data } = await api.post('/auth/signup', {
      name, email, password, role,
      companyName: role === 'agent' ? companyName : undefined,
      companyCountry: role === 'agent' ? country : undefined,
    });
    return data.data;
  },

  async verifyOtp(email, otp) {
    const { data } = await api.post('/auth/verify-otp', { email, otp });
    return data;
  },

  async resendOtp(email) {
    const { data } = await api.post('/auth/resend-otp', { email });
    return data;
  },

  async login(email, password) {
    const { data } = await api.post('/auth/login', { email, password });
    return data.data;
  },

  async refresh(refreshToken) {
    const { data } = await api.post('/auth/refresh', { refreshToken });
    return data.data;
  },

  async googleSignIn(idToken, role, companyName, country) {
    const { data } = await api.post('/auth/google', { idToken, role, companyName, country });
    return data.data;
  },

  async logout() {
    const { data } = await api.post('/auth/logout');
    return data;
  },

  async getMe() {
    const { data } = await api.get('/auth/me');
    return data.data;
  },

  async forgotPassword(email) {
    const { data } = await api.post('/auth/forgot-password', { email });
    return data;
  },

  async resetPassword(email, otp, newPassword) {
    const { data } = await api.post('/auth/reset-password', { email, otp, newPassword });
    return data;
  },

  async resetPasswordByPhone(phone, phoneCode, otp, newPassword) {
    const { data } = await api.post('/auth/reset-password-by-phone', { phone, phoneCode, otp, newPassword });
    return data;
  },

  async sendPhoneOtp({ phone, phoneCode, purpose, name, role, companyName, country }) {
    const { data } = await api.post('/auth/send-phone-otp', {
      phone, phoneCode, purpose, name, role,
      companyName: role === 'agent' ? companyName : undefined,
      companyCountry: role === 'agent' ? country : undefined,
    });
    return data;
  },

  async sendIdentityEmailOtp() {
    const { data } = await api.post('/auth/send-identity-otp');
    return data;
  },

  async verifyPhoneOtp({ phone, phoneCode, otp, purpose, name, role, companyName, country }) {
    const { data } = await api.post('/auth/verify-phone-otp', {
      phone, phoneCode, otp, purpose, name, role,
      companyName: role === 'agent' ? companyName : undefined,
      companyCountry: role === 'agent' ? country : undefined,
    });
    return data.data;
  },

  async sendEmailChangeOtp() {
    const { data } = await api.post('/auth/send-email-change-otp');
    return data;
  },

  async verifyEmailChange(otp) {
    const { data } = await api.post('/auth/verify-email-change', { otp });
    return data;
  },
};

export default AuthService;
